import { useMutation } from "@apollo/client"
import { CreateGameMutation } from '../gql/mutations'
import { useEffect, useState } from "react"
import { LOBBY_TIMEOUT } from "../config"

interface CreateGameStatus {
  loading: boolean,
  called: boolean,
  error: any,
  data: any,
}
export const useCreateGame = (playerId: string, playerDisplayName: string, questionSet: number = 1, isPrivate: boolean = false): [Function, CreateGameStatus] => {
  const [createGame, createGameStatus] = useMutation(CreateGameMutation)
  const [loading, setLoading] = useState(false)
  const [called, setCalled] = useState(false)
  const [data, setData] = useState<null | string>(null)
  const [error, setError] = useState<null | string>(null)

  const createGameFunc = () => {
    setLoading(true)
    setCalled(true)
    const dateStart = new Date(Date.now())
    dateStart.setSeconds(dateStart.getSeconds() + LOBBY_TIMEOUT)
    console.log(playerId)
    createGame({
      variables: {
        isPrivate: isPrivate,
        questionSet: questionSet,
        PlayerId: playerId,
        PlayerDisplayName : playerDisplayName,
        dateStart: dateStart.toISOString()
      }
    })
  }
  useEffect(() => {
    const gameData = createGameStatus.data
    if (!createGameStatus.loading) {
      if (gameData && gameData.createGame) {
        setData(gameData.createGame.id)
        setLoading(false)
      }
      if(createGameStatus.error){
        setError(createGameStatus.error.message)
      }
    }

  }, [createGameStatus])

  return [createGameFunc, { loading, called, error, data }]
}